import { useState, useEffect } from "react";
import { format } from "date-fns";

export default function App() {
  const [serviceNumber, setServiceNumber] = useState("");
  const [amount, setAmount] = useState("");
  const [slip, setSlip] = useState(null);
  const [status, setStatus] = useState(null);
  const [submissions, setSubmissions] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!serviceNumber || !amount || !slip) {
      setStatus("Please fill in all fields.");
      return;
    }
    const formData = new FormData();
    formData.append("serviceNumber", serviceNumber);
    formData.append("amount", amount);
    formData.append("slip", slip);
    try {
      const res = await fetch("https://nooudu.mv/api/submit-bill.php", {
        method: "POST",
        body: formData,
      });
      if (res.ok) {
        setStatus("Bill submitted successfully.");
        setServiceNumber("");
        setAmount("");
        setSlip(null);
        fetchSubmissions();
      } else {
        setStatus("Submission failed. Try again.");
      }
    } catch (err) {
      setStatus("An error occurred.");
    }
  };

  const fetchSubmissions = async () => {
    try {
      const res = await fetch("https://nooudu.mv/api/get-submissions.php");
      const data = await res.json();
      setSubmissions(data);
    } catch (err) {
      console.error("Failed to fetch submissions", err);
    }
  };

  useEffect(() => {
    fetchSubmissions();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial' }}>
      <h1>Nooudu Pay</h1>

      <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
        <div>
          <input
            type="text"
            placeholder="Service Number"
            value={serviceNumber}
            onChange={(e) => setServiceNumber(e.target.value)}
          />
        </div>
        <div>
          <input
            type="number"
            placeholder="Amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>
        <div>
          <input
            type="file"
            onChange={(e) => setSlip(e.target.files[0])}
          />
        </div>
        <button type="submit">Submit Bill</button>
        {status && <p>{status}</p>}
      </form>

      <h2>Admin Dashboard</h2>
      <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>TIME</th>
            <th>NUMBER</th>
            <th>AMOUNT</th>
            <th>STATUS</th>
            <th>SLIP</th>
          </tr>
        </thead>
        <tbody>
          {submissions.map((item, idx) => (
            <tr
              key={idx}
              style={{ backgroundColor: item.status === "pending" ? "orange" : "lightblue" }}
            >
              <td>{format(new Date(item.createdAt), 'yyyy-MM-dd HH:mm')}</td>
              <td>{item.serviceNumber}</td>
              <td>MVR {item.amount}</td>
              <td>{item.status}</td>
              <td>
                {item.slipPath && (
                  <a href={item.slipPath} target="_blank" rel="noopener noreferrer">View Slip</a>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

